import axios from 'axios';
import config from '../config/env.config';

const API_BASE_URL = config.api.baseURL;

const getCurrentLanguage = () => {
  const nameEQ = "language=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return 'nl';
};

const createApiWithLanguage = (language = null) => {
  const currentLanguage = language || getCurrentLanguage();
  return axios.create({
    baseURL: API_BASE_URL,
    timeout: config.api.timeout,
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': currentLanguage,
    },
  });
};

export const submitContactForm = async (formData, language = null) => {
  try {
    const apiInstance = createApiWithLanguage(language);
    const response = await apiInstance.post('/messages', formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};
